import { useMemo } from 'react';

import { ConsolidatedForecastReport, VIEW_TYPES } from '../../../../../core/types';
import { getColumnsWithFYInfo } from '../../utils/forecast-columns';
import { usePredictionsInfoContext } from '../../../context/predictions-info-context';
import { usePredictManagementContext } from '../../../../../predict-management/context/predict-management-context';

/**
 * Returns the columns to use when displaying a forecast. columnsWithFYInfo will have the FY columns
 * added to the array if applicable (if the current periodType is monthly).
 * @param forecastReport - Forecast report data
 */
export const useForecastColumns = (forecastReport: ConsolidatedForecastReport | null | undefined) => {
  const { viewType, periodType } = usePredictionsInfoContext();
  const { financialConfig } = usePredictManagementContext();

  const { columns, columnsWithFYInfo } = useMemo(() => {
    let columns: string[] = [];
    let columnsWithFYInfo: string[] = [];

    if (forecastReport) {
      // sort out which columns data to use
      if (viewType === VIEW_TYPES.CASH_FLOW) {
        columns = forecastReport.data.cash_flow_columns;
      } else {
        columns = forecastReport.data.columns;
      }

      // now sort out the columns with FY info added
      if (financialConfig && periodType === 'MONTHLY') {
        columnsWithFYInfo = getColumnsWithFYInfo(forecastReport.data.columns, financialConfig);
      } else {
        columnsWithFYInfo = columns;
      }
    }
    return { columns, columnsWithFYInfo };
  }, [financialConfig, forecastReport, periodType, viewType]);

  return { columns, columnsWithFYInfo };
};
